
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { Work } from "@/interfaces/work";

export default defineComponent({
  name: "WorkModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    work: {
      type: Object as PropType<Work | null>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const closing = ref(false);
    const personalProjectTag = "Personal Project";
    const corporateWorkTag = "Corporate Work";

    const workModalClass = ref({
      work_modal: true,
    });

    const projectType = computed(() =>
      props.work?.github ? personalProjectTag : corporateWorkTag
    );

    const technologyTags = computed(() =>
      (props.work?.tags || []).filter(
        (tag) => tag !== personalProjectTag && tag !== corporateWorkTag
      )
    );

    const projectTypeClass = computed(() => ({
      "work_modal__project_type--personal":
        projectType.value === personalProjectTag,
      "work_modal__project_type--corporate":
        projectType.value === corporateWorkTag,
    }));

    const onClose = () => {
      emit("updateModal", false, null);
      closing.value = true;
    };

    watch(closing, (prevValue, currentValue) => {
      if (prevValue === true && currentValue === false) {
        setTimeout(() => {
          closing.value = false;
        }, 1000);
      }
    });

    return {
      workModalClass,
      closing,
      onClose,
      projectType,
      technologyTags,
      projectTypeClass,
    };
  },
});
